module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-8.427df088.jpg";